import { routesTemplate } from '../routesTemplate';

import ProfileScreen from '../../screens/profile/ProfileScreen';

export const profileStack = [
	routesTemplate('/profile', ProfileScreen, 'Perfil'),
];